import { render, staticRenderFns } from "./EventMapping.vue?vue&type=template&id=3bf86b82&scoped=true"
import script from "./EventMapping.vue?vue&type=script&lang=js"
export * from "./EventMapping.vue?vue&type=script&lang=js"
import style0 from "./EventMapping.vue?vue&type=style&index=0&id=3bf86b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf86b82",
  null
  
)

export default component.exports